import angular from 'angular';
import books from '../books';
import { BooksControllerDirective } from './dom/booksController';
import { MenuServiceFactory } from './services/MenuService';
import { booksMenuComponent, MenuItemTemplateCache } from './dom/booksMenu';
import { ChangeLoginDialogService } from './dialogs/ChangeLoginDialog';
import { ChangeProfileDialogService } from './dialogs/ChangeProfileDialog';
import { ConfirmLogoutDialogService } from './dialogs/ConfirmLogoutDialog';

export default angular
  .module('csm.books.Menu', ['ui.bootstrap', books])
  .run(runInitApp)
  .directive('booksController', BooksControllerDirective)
  .factory('MenuService', MenuServiceFactory)
  .run(MenuItemTemplateCache)
  .component('booksMenu', booksMenuComponent)
  .service('ChangeLoginDialog', ChangeLoginDialogService)
  .service('ChangeProfileDialog', ChangeProfileDialogService)
  .service('ConfirmLogoutDialog', ConfirmLogoutDialogService).name;

/*******************************************************************************
 * Run: runInitApp */
/**
 * Initializes the menu application.
 *******************************************************************************/
/* @ngInject */ function runInitApp($injector, $rootScope, SERVER) {
  /*----------------------------------------------------------------------*/
  /* There is a bug with the ngView directive such that when it is loaded */
  /* as part of transcluded content, instantiation of ngView and the      */
  /* $route service is delayed and the first location change event will   */
  /* be missed. To fix this, we need to instantiate the $route service    */
  /* during a run block. Problem still exists in AngularJS 1.5.11.        */
  /*                                                                      */
  /* https://github.com/angular/angular.js/issues/1213                    */
  /*----------------------------------------------------------------------*/
  if ($injector.has('$route')) $injector.get('$route');

  /*-----------------------------------------*/
  /* Add server constants to the root scope. */
  /*-----------------------------------------*/
  $rootScope.booksWebConstants = SERVER.BooksWebConstants;
}
